var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg040Compass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.104,147.819c-5.82-5.789-14.589-7.431-22.111-4.146l-222,97c-7.433,3.248-12.169,10.665-11.987,18.774 c0.181,8.111,5.244,15.308,12.815,18.22l82.703,31.809l31.418,81.688C238.872,403.97,249.703,405,253.018,405 c0.021,0,0.044,0,0.066,0c7.959-0.033,15.141-4.782,18.287-12.092l96-223C370.617,162.367,368.925,153.609,363.104,147.819z  M254.041,332c-6.104-15.872-12.605-32.777-17.375-45.179c-2.031-5.282-6.205-9.457-11.487-11.488l-45.53-17.512l130.958-57.22 L254.041,332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.813,0,92.617-12.758,132.462-36.893 c9.447-5.724,12.467-18.022,6.744-27.469c-5.724-9.449-18.022-12.467-27.469-6.744C334.144,461.244,295.505,472,256,472 c-119.103,0-216-96.897-216-216S136.897,40,256,40s216,96.897,216,216c0,42.589-12.665,84.044-36.626,119.884 c-6.139,9.182-3.672,21.603,5.51,27.742c9.184,6.139,21.604,3.672,27.742-5.51C497.002,355.674,512,306.53,512,256 C512,187.62,485.371,123.333,437.02,74.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg040Compass);
export default __webpack_public_path__ + "static/media/040-compass.3817fa1ce09186db976d44ea516ca626.svg";
export { ForwardRef as ReactComponent };